export default __webpack_public_path__ + "static/media/ic-warning.795e90af.svg";